import { useAdd } from "@/pages/ExpenseDetail/comps/Add/index.jsx";
import type { Dayjs } from "dayjs";
import { memo, useMemo } from "react";
import isEqual from "react-fast-compare";
import { Link, useNavigate } from "react-router-dom";
import { useLongPress } from "use-long-press";
import useExpenseAdd from "../../hooks/useExpenseAdd.js";

function getFullWeeksBetween(startDate: Date, endDate: Date) {
	// 创建 Date 对象并确保它们是副本，避免修改原始输入
	const start = new Date(startDate.getTime());
	const end = new Date(endDate.getTime());

	// 定义一周的开始（例如：0 表示星期日，1 表示星期一）
	const weekStartDay = 1; // 假设一周从周一（1）开始

	// 将起始日期调整到本周的第一天
	start.setDate(start.getDate() - ((start.getDay() + 7 - weekStartDay) % 7));
	// 将结束日期调整到本周的最后一天
	end.setDate(end.getDate() + (6 - ((end.getDay() + 6 - weekStartDay) % 7)));

	// 如果调整后的开始日期晚于结束日期，则没有完整的周
	if (start > end) return 0;

	// 计算两个日期之间的毫秒差，然后转换为天数，再除以7得到周数
	const diffInMs = +end - +start;
	const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
	const fullWeeks = Math.floor(diffInDays / 7);

	return fullWeeks; // 包含起始周
}

const Header = memo(
	({
		startTime,
		endTime,
		title,
		planId,
	}: {
		startTime: Dayjs;
		endTime: Dayjs;
		title?: string;
		planId: string;
	}) => {
		const diffWeek = useMemo(
			() => getFullWeeksBetween(startTime.toDate(), endTime.toDate()),
			[],
		);
		const diffDay = useMemo(() => endTime.diff(startTime, "day") + 1, []);
		const expenseAddProps = useExpenseAdd({ planId });

		return (
			<header className="pb-8 px-5  -mb-4 ">
				<div className="flex items-center justify-between">
					<b className=" text-[32px]">{title}</b>

					<i
						className="ic-round md-attach_money text-base w-8 h-8 rounded-full border-2 border-black/15 !flex items-center justify-center hover:scale-70 transition-all select-none "
						{...expenseAddProps}
					/>
				</div>
				<div>
					<span className="flex items-center text-[#707070] text-sm font-[600]">
						{startTime.format("MM.DD")}至{endTime.format("MM.DD")} {diffDay}天
						{diffWeek > 1 && `${diffWeek}周`}
						<i className="ic-round md-keyboard_arrow_right" />
					</span>
				</div>
			</header>
		);
	},
	isEqual,
);

export default Header;
